import { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import {
  createStyles,
  jssPreset,
  makeStyles,
  StylesProvider,
  ThemeProvider,
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'moment/locale/es';

import {
  Auth,
  ScrollReset,
  WssProvider,
} from 'components';
import Routes from 'routes';
import { createTheme } from 'theme';
import NetworkStatusNotifier from 'components/NetworkStatusNotifier';
import { initSettings, getSettings } from 'utils/settings';

const history = createBrowserHistory();
const jss = create({
  plugins: [...jssPreset().plugins, rtl()],
});
const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
        overflow: 'hidden',
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
    },
  }),
);

function App() {
  const [themeSettings, setThemeSettings] = useState({});
  const [isSettingsReady, setIsSettingsReady] = useState(false);
  useStyles();

  useEffect(() => {
    const loadSettings = async () => {
      await initSettings();
      const settings = getSettings('theme', {});
      setThemeSettings(settings);
      setIsSettingsReady(true);
    };
    loadSettings();
  }, []);

  if (!isSettingsReady) {
    return <div style={{
      width: '100%',
      height: '100%',
      backgroundColor: '#f4f6f8',
    }} />;
  }

  return (
    <ThemeProvider theme={createTheme(themeSettings)}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils} locale="es">
          <SnackbarProvider maxSnack={1}>
            <NetworkStatusNotifier />
            <Router history={history}>
              <Auth>
                <WssProvider />
                <ScrollReset />
                <Routes />
              </Auth>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
}

export default App;
